export default __webpack_public_path__ + "static/media/FreeForMe_159x150.dbd07025.png";